import { RecordBase } from './RecordBase';

export class EnterExitDailyRecord extends RecordBase {
    stat_date!: string;
    address!: string;
    in!: number;
    out!: number;
}
